import type { ReactElement } from 'react'

const INPUT_CLASS =
  'w-full rounded-lg border border-stone-300 px-3 py-2 text-sm focus:border-[#4e5e82] focus:outline-none focus:ring-1 focus:ring-[#4e5e82] dark:border-stone-600 dark:bg-stone-700 dark:text-white'
const LABEL_CLASS = 'mb-1 block text-sm font-medium text-stone-600 dark:text-stone-400'

type ChangeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void

interface DateFieldProps {
  id: string
  name: string
  value: string
  label: string
  onChange: ChangeHandler
}

export function DateField({ id, name, value, label, onChange }: DateFieldProps): ReactElement {
  return (
    <div>
      <label htmlFor={id} className={LABEL_CLASS}>
        {label}
      </label>
      <input
        type="date"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={INPUT_CLASS}
      />
    </div>
  )
}

interface UuidFieldProps {
  id: string
  name: string
  value: string
  label: string
  placeholder: string
  onChange: ChangeHandler
}

export function UuidField({
  id,
  name,
  value,
  label,
  placeholder,
  onChange,
}: UuidFieldProps): ReactElement {
  return (
    <div>
      <label htmlFor={id} className={LABEL_CLASS}>
        {label}
      </label>
      <input
        type="text"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={INPUT_CLASS}
      />
    </div>
  )
}
